import { useQuery } from '@tanstack/react-query'
import { apiInstance } from 'services/api'
import { useMasquaradeToken } from 'services/masquarade/masquarade.hooks'
import { useAccessToken } from 'services/token/token.hooks'

export interface LeaseContractsAnnexesResponse {
  id: number
  signedDate: string
  startDate: string
  scanFile: string
}

export const useLeaseContractsAnnexes = (id: number) => {
  const { accessToken } = useAccessToken()
  const { masquaradeToken } = useMasquaradeToken()

  const { data: leaseContractsAnnexes = [], ...rest } = useQuery({
    queryKey: ['leaseContractsAnnexes', id, masquaradeToken],
    queryFn: () =>
      apiInstance<LeaseContractsAnnexesResponse[]>({
        url: `/lease/contracts/${id}/annexes`,
        method: 'GET',
        headers: {
          authorization: `Bearer ${accessToken}`,
          'mask-authorization': !!masquaradeToken ? `Token ${masquaradeToken}` : undefined
        }
      }).then(({ data }) => data),
    enabled: !!accessToken
  })

  return {
    leaseContractsAnnexes,
    ...rest
  }
}
